/**
   * @license
   * author: Rajan Palaniya <rajan.palaniya@infostretch.com>
   * @jetprivilege/web v3.2.8
   * Released under the ISC license.
   */
"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),require("../_rollupPluginBabelHelpers-64cee8b0.js"),require("react");var e=require("../breadcrumb-04113c66.js");exports.Breadcrumb=e.Breadcrumb;
